import React from 'react';
import AsyncSelect from 'react-select/async';
import { debounce } from 'lodash';
import { Col, Row } from 'react-bootstrap';
import { handleThunkException } from '~/services/thunk.service';
import biomeApi from '../biome.api';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { addBiomeAdventureItem } from '../biomeSlice';
import PropTypes from 'prop-types';

function AdventureFilter({ keyAsyncSelect, setKeyAsyncSelect }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    const _loadOptions = (inputValue, callback) => {
        biomeApi
            .getAdventure(params.id, inputValue)
            .then((data) => {
                const options = data.map((item) => ({
                    label: item.name,
                    value: item.id,
                }));
                callback(options);
            })
            .catch((error) => {
                handleThunkException(error, dispatch, navigate);
            });
    };

    const loadOptions = debounce(_loadOptions, 300);

    const addAdventure = async (option) => {
        try {
            await biomeApi.addAdventure(params.id, option.value);
            dispatch(
                addBiomeAdventureItem({
                    id: option.value,
                    adventure_name: option.label,
                    qty: 0,
                }),
            );
            setKeyAsyncSelect(keyAsyncSelect + 1);
        } catch (error) {
            handleThunkException(error, dispatch, navigate);
        }
    };

    return (
        <Row
            sm={12}
            className="justify-content-center my-4"
        >
            <Col sm={4}>
                <AsyncSelect
                    key={keyAsyncSelect}
                    defaultOptions
                    loadOptions={loadOptions}
                    placeholder={'Select an adventure to add to the biome'}
                    onChange={(option) => {
                        addAdventure(option);
                    }}
                    value={null}
                />
            </Col>
        </Row>
    );
}

AdventureFilter.propTypes = {
    keyAsyncSelect: PropTypes.number.isRequired,
    setKeyAsyncSelect: PropTypes.func.isRequired,
};

export default AdventureFilter;
